// src/pages/RegisterPage.js
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import toast from "react-hot-toast";

const INPUT = { width: "100%", padding: "11px 14px", border: "1.5px solid #e2ece2", borderRadius: 8, fontFamily: "inherit", fontSize: 14, color: "#1a2e1a", background: "white" };

export default function RegisterPage() {
  const { signUp, loginWithGoogle } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", phone: "", password: "", confirm: "" });
  const [loading, setLoading] = useState(false);
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.password !== form.confirm) { toast.error("Passwords do not match"); return; }
    if (form.password.length < 6) { toast.error("Password must be at least 6 characters"); return; }
    if (form.phone.length !== 10) { toast.error("Enter a valid 10-digit mobile number"); return; }
    setLoading(true);
    try {
      await signUp(form.name, form.email, form.password, form.phone);
      toast.success("Account created! Welcome to ApnaSatna.");
      navigate("/dashboard");
    } catch (err) {
      const msg = err.code === "auth/email-already-in-use" ? "This email is already registered." : "Registration failed. Try again.";
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  const handleGoogle = async () => {
    setLoading(true);
    try {
      await loginWithGoogle();
      toast.success("Registered with Google!");
      navigate("/dashboard");
    } catch {
      toast.error("Google sign-in failed.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: "85vh", display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}>
      <div style={{ width: "100%", maxWidth: 440 }}>
        <div style={{ textAlign: "center", marginBottom: 24 }}>
          <div style={{ fontSize: 40, marginBottom: 6 }}>🏠</div>
          <h1 style={{ fontFamily: "'Sora',sans-serif", fontWeight: 700, fontSize: 24, color: "#1a6b3c" }}>
            Apna<span style={{ color: "#f59e0b" }}>Satna</span>
          </h1>
          <p style={{ color: "#6b7c6b", fontSize: 14, marginTop: 4 }}>Create your free account</p>
        </div>

        <div style={{ background: "white", borderRadius: 16, padding: "28px 24px", border: "1px solid #e2ece2", boxShadow: "0 4px 20px rgba(0,0,0,0.06)" }}>
          <form onSubmit={handleSubmit}>
            {[
              { label: "Full Name *", key: "name",    type: "text",     placeholder: "Ramesh Kumar" },
              { label: "Email Address *", key: "email", type: "email",  placeholder: "ramesh@email.com" },
              { label: "Mobile Number *", key: "phone", type: "tel",    placeholder: "10-digit number", maxLen: 10 },
              { label: "Password *",    key: "password", type: "password", placeholder: "Min 6 characters" },
              { label: "Confirm Password *", key: "confirm", type: "password", placeholder: "Repeat password" },
            ].map(f => (
              <div key={f.key} style={{ marginBottom: 14 }}>
                <label style={{ fontSize: 13, fontWeight: 600, color: "#1a2e1a", display: "block", marginBottom: 5 }}>{f.label}</label>
                <input type={f.type} value={form[f.key]} onChange={e => set(f.key, f.key === "phone" ? e.target.value.replace(/\D/g, "") : e.target.value)}
                  placeholder={f.placeholder} required maxLength={f.maxLen} style={INPUT} />
              </div>
            ))}

            <div style={{ background: "#f0fff4", border: "1px solid #c3e6cb", borderRadius: 8, padding: "10px 13px", marginBottom: 14, fontSize: 12, color: "#1a6b3c" }}>
              ✓ Free account &nbsp;·&nbsp; ✓ Post unlimited listings &nbsp;·&nbsp; ✓ Direct buyer contact
            </div>

            <button type="submit" disabled={loading} style={{
              width: "100%", padding: "13px", borderRadius: 9,
              background: loading ? "#a8d5b9" : "#1a6b3c", color: "white",
              border: "none", fontWeight: 700, fontSize: 15, cursor: loading ? "not-allowed" : "pointer", fontFamily: "inherit"
            }}>
              {loading ? "Creating account..." : "Create Free Account →"}
            </button>
          </form>

          <div style={{ display: "flex", alignItems: "center", gap: 10, margin: "16px 0" }}>
            <div style={{ flex: 1, height: 1, background: "#e2ece2" }} />
            <span style={{ fontSize: 12, color: "#6b7c6b" }}>OR</span>
            <div style={{ flex: 1, height: 1, background: "#e2ece2" }} />
          </div>

          <button onClick={handleGoogle} disabled={loading} style={{
            width: "100%", padding: "12px", borderRadius: 9,
            background: "white", color: "#1a2e1a", border: "1.5px solid #e2ece2",
            fontWeight: 600, fontSize: 14, cursor: "pointer", fontFamily: "inherit",
            display: "flex", alignItems: "center", justifyContent: "center", gap: 8
          }}>
            <svg width="18" height="18" viewBox="0 0 24 24"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/><path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/></svg>
            Continue with Google
          </button>
        </div>

        <p style={{ textAlign: "center", marginTop: 18, fontSize: 14, color: "#6b7c6b" }}>
          Already have an account? <Link to="/login" style={{ color: "#1a6b3c", fontWeight: 700 }}>Login →</Link>
        </p>
      </div>
    </div>
  );
}
